import { NgModule } from '@angular/core'

declare global {
  interface JSON {
    tryParse: (object: any) => any
  }
}
JSON.tryParse = (object: any) => {
  try {
    return JSON.parse(object)
  } catch (e) {
    return undefined
  }
}
